import React from 'react';
import PropTypes from 'prop-types';
import { ClaimDetailPropTypes } from '../../../propTypes/claimDetails';
import { FullPetDetailsPropTypes } from '../../../propTypes/petDetails';
import { ClaimDetailItem } from './claimDetailItem';

import './claimDetails.scss';

export const ClaimDetails = ({
  claimDetails,
  petDetails,
  includeDescription = true,
  icon = 'paw',
  includeCompleteButton = false,
  includeDeleteButton = false
}) => {
  return (
    <ul className="claimDetails">
      {claimDetails?.map((claim) => (
        <li key={claim.ClaimNumber || claim.CustomerClaimId}>
          <ClaimDetailItem
            claim={claim}
            petDetails={petDetails}
            includeDescription={includeDescription}
            icon={icon}
            includeCompleteButton={includeCompleteButton}
            includeDeleteButton={includeDeleteButton}
          />
        </li>
      ))}
    </ul>
  );
};

ClaimDetails.propTypes = {
  claimDetails: PropTypes.arrayOf(PropTypes.shape(ClaimDetailPropTypes)),
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  includeDescription: PropTypes.bool,
  icon: PropTypes.string,
  includeCompleteButton: PropTypes.bool,
  includeDeleteButton: PropTypes.bool
};
